import { postForgotPassword } from "api/authAPI";
import { UnderlineText } from "components/atoms/text/Text";
import useApiError from "hook/useApiError";
import useStatusMutation from "hook/useStatusMutation";
import { useCallback } from "react";
import { COLORS } from "styles/colors";
import { LOGIN_STEP, LoginInfo } from "../LoginContainer";
import { CustomError } from "api/interfaces/commonInterface.interface";

export default function ForgotPassword({
  loginInfo,
  onChangeStep,
}: {
  loginInfo: LoginInfo;
  onChangeStep: (step: LOGIN_STEP) => void;
}) {
  const { handleErrorNotify, lang } = useApiError();
  const mutationForgotPassword = useStatusMutation(postForgotPassword, {
    onSuccess: () => {
      onChangeStep(LOGIN_STEP.FORGOT_PASSWORD);
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.validateMsg.signup.noExistEmail);
    },
  });
  const onClickForgotPassword = useCallback(() => {
    if (!mutationForgotPassword.idle) return;
    mutationForgotPassword.mutate({
      payload: {
        email: loginInfo.email,
      },
    });
  }, [loginInfo]);
  return (
    <UnderlineText
      id="dw_login_button_forward_forgotEmail"
      fontSize={14}
      color={COLORS.BUTTONS2}
      onClick={onClickForgotPassword}
      data-testid="auth-signin-forgot-forward-forgot-email-click-forgot-password"
    >
      Forgot Password?
    </UnderlineText>
  );
}
